@if(!!data && !!years) {
<div class="timeline-filters-container">
    <mat-divider></mat-divider>
    <div class="timeline-years">
        @for(year of years; let i = $index; track year.date) {
        <div class="se-year" [ngClass]="{'single-year': data.length === 1, 'monthly-view-years': isMonthlyView, 'hide-last-year': maxValueAllowed === 13, 'hide-first-year': minValueAllowed === 1}">

            <span [ngClass]="{
                'months-display': isMonthlyView,
                'first-last-month': isMonthlyView && i === 0 || isMonthlyView && i === years.length - 1,
                'start-month': isMonthlyView && i === 1,
                'end-month': isMonthlyView && i === years.length - 2}">
                {{ year.description | translate }}

                @if(isMonthlyView && i === 1 && this.data.length > 1 || isMonthlyView && i === 0 && this.data.length === 1 || isMonthlyView && i === years.length - 2) {
                <span class="added-year">{{currentYear}}</span>
                }
            </span>

            @if(points) {
            <div class="se-year-width">
                @for(data of points[year?.date]; track $index) {
                <div class="timeline-events-point"
                     [ngClass]="{'out-of-range': _isOutOfRange(data, year)}"
                     [style.left.px]="data.position">

                    <div class="custom-tooltip">
                        @if(data.grouped){
                        <span>{{ data.grouped.length }}</span>
                        }
                        @else {
                        <span>1</span>
                        }
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>

    @if(!!years && this.data.length > 1) {
    <div class="slider-container">
        @if(!isMonthlyView && startValue && endValue) {
        <div>
            <mat-slider [showTickMarks]="true"
                        [disableRipple]="true"
                        [min]="years[0]?.date"
                        [max]="years[years.length - 1]?.date">
                <input class="slider--input input--min" [value]="startValue" matSliderStartThumb (valueChange)="_onStartValueChange($event)">
                <input class="slider--input input--max" [value]="endValue" matSliderEndThumb (valueChange)="_onEndValueChange($event)">
            </mat-slider>
        </div>
        }

        @if(isMonthlyView) {
        <div>
            <mat-slider [showTickMarks]="true"
                        [disableRipple]="true"
                        [min]="minValueAllowed"
                        [max]="maxValueAllowed">
                <input class="slider--input input--min" value="1" matSliderStartThumb (valueChange)="_onStartMonthValueChange($event)">
                <input class="slider--input input--max" value="13" matSliderEndThumb (valueChange)="_onEndMonthValueChange($event)">
            </mat-slider>
        </div>
        }
    </div>
    }

    @if(isMonthlyView && this.data.length === 1) {
    <div class="slider-container">
        <se-timeline-months-slider [years]="years" (filtersValue)="_onFiltersValueChange($event)"></se-timeline-months-slider>
    </div>
    }

</div>
}

